import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { JwtModule } from "@auth0/angular-jwt";

import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { IConfig, provideNgxMask } from 'ngx-mask';
import { firstValueFrom } from 'rxjs';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ComponentsModule } from "./core/components/components.module";
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { HttpErrorInterceptor } from './core/interceptors/http-error.interceptor';
import { InterceptorInterceptor } from './core/interceptors/interceptor.interceptor';
import { SessionExpiredInterceptor } from './core/interceptors/session-expired.interceptor';
import { AuthService } from './core/services/auth.service';
import { MaterialAngularModule } from './material-angular.module';
import { SecurityContextInterceptor } from './core/interceptors/security-context.interceptor';



export const options: Partial<null | IConfig> | (() => Partial<IConfig>) = null;
const maskConfigFunction: () => Partial<IConfig> = () => {
  return {
    validation: false,
  };
};
@NgModule({
  declarations: [
    AppComponent
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: (auth: AuthService) => () =>
        firstValueFrom(auth.loadUserSession()),
      deps: [AuthService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SecurityContextInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SessionExpiredInterceptor,
      multi: true,
    },
    provideNgxMask(maskConfigFunction),
  ],
  bootstrap: [AppComponent],
  imports: [
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ComponentsModule,
    MaterialAngularModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: () => sessionStorage.getItem('tokenMotor'),
        allowedDomains: [],
        disallowedRoutes: [],
      },
    }),
  ]
})
export class AppModule {

}
